var _defs, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPzo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-miterlimit:10;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.9,
    y: 0.9,
    width: 18.2,
    height: 18.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23,12.76v4H5.42V5.07h4.64a5.35,5.35,0,0,1,2.36.5A3.69,3.69,0,0,1,14,7,3.91,3.91,0,0,1,14.58,9a3.37,3.37,0,0,1-1.22,2.72,5,5,0,0,1-3.34,1Zm0-2.16h1.83a1.76,1.76,0,0,0,1.25-.41A1.53,1.53,0,0,0,11.73,9a1.81,1.81,0,0,0-.44-1.3,1.54,1.54,0,0,0-1.19-.5H8.23Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPzo);
export default __webpack_public_path__ + "static/media/pzo.d62da9ec9bb0495b39b3a57be923f2f6.svg";
export { ForwardRef as ReactComponent };